import { Handle, Position } from "reactflow";
import { mdiAccountOutline } from "@mdi/js";
import Icon from "@mdi/react";
import NoteTooltip from "../misc/NoteTooltip";

export default function PromptNode({ data }) {
  const icon = <Icon path={mdiAccountOutline} size={1} color="white"></Icon>;
  return (
    <div>
      <div className="PromptNode">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div>{icon}</div>
          <div>
            {data.advanced.note ? (
              <NoteTooltip title={data.advanced.note}></NoteTooltip>
            ) : (
              <></>
            )}
          </div>
        </div>
        <Handle
          className="PlaybookHandle"
          type="target"
          position={Position.Top}
          isConnectable={false}
        />
        <Handle
          className="PlaybookHandle"
          type="source"
          position={Position.Bottom}
          id="a"
          isConnectable={false}
        />
      </div>
    </div>
  );
}
